/// <reference path="../services/logservice.ts" />
/// <reference path="../screenmode.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../services/navigationhelperservice.ts" />
/// <reference path="../services/formhelperservice.ts" />
/// <reference path="controllerbase.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../services/globalsettingsservice.ts" />
/// <reference path="../services/usermessagesservice.ts" />
/// <reference path="iscreencontroller.d.ts" />
/// <reference path="../isessionstorage.d.ts" />
/// <reference path="../ilocalstorage.d.ts" />
/// <reference path="../messageboxconfig.ts" />

module App.Common.Controllers {
	'use strict';

	export abstract class ScreenControllerBase extends ControllerBase implements Controllers.IScreenController, Controllers.IInitialize {

		public busyPromise: angular.IPromise<any>;
		public fullWidth = false;
		public forceReauthentication = false;
		public scroll = 0;
		private authenticationRequired: boolean = null;

		constructor(public $injector: angular.auto.IInjectorService) {
			super($injector);

			this.userMessages.collectDeferredMessages();
			this.registerFormFooterAnchor();

			this.$document.scrollTop(0);
			this.navigationHelper.currentScreen = this;

			this.busyPromise = this.beforeInitialize()
				.then(() => {
					if (_.isNil(this.authenticationRequired)) {
						//If beforeInitialize() didn't call setAuthenticationRequired(), assume authentication IS required
						return this.setAuthenticationRequired(true);
					}
					return this.$q.resolve();
				})
				.then(() => {
					return this.$q.all([this.navigationHelper.runInitializers(), this.initialize()]);
				});
		}

		public beforeInitialize(): angular.IPromise<any> {
			return this.$q.resolve();
		}

		public setAuthenticationRequired(isRequired: boolean): angular.IPromise<any> {

			this.authenticationRequired = isRequired;

			if (this.authenticationRequired) {
				return this.authentication.ensureAuthentication(this.forceReauthentication);
			} else {
				return this.$q.resolve();
			}
		}

		public isAuthenticationRequired() {
			return this.authenticationRequired;
		}

		public notForWindowsAuthenticationUsers() {
			if (this.authentication.useWindowsAuthentication()) {
				this.$state.go('NotForWindowsAuthenticationUsers', null, {
					location: false,
					suppressUnsavedChangesWarning: true
				} as Common.IStateOptions);
			}
		}

		public checkScreenPermissions(
			read: Hca.HiLO.Model.Identity.Permissions | Hca.HiLO.Model.Identity.Permissions[],
			edit: Hca.HiLO.Model.Identity.Permissions | Hca.HiLO.Model.Identity.Permissions[] = null
		): boolean {

			var currentUser = this.users.getCurrentUser();
			var readPermissions = read ? _.flatten([read]) : [];
			var editPermissions = edit ? _.flatten([edit]) : [];

			if (!_(currentUser.permissions).some((x: Hca.HiLO.Model.Identity.Permissions) => (readPermissions.some(r => r === x)))) {
				this.userMessages.addMessage('You do not have the required permission to access this screen', UserMessageType.Error);
				this.screenMode = ScreenMode.NoAccess;
				this.$state.go('NoScreenAccess');
				return false;
			} else if (editPermissions &&
				editPermissions.length &&
				!_(currentUser.permissions).some((x: Hca.HiLO.Model.Identity.Permissions) => (editPermissions.some(r => r === x)))) {
				this.screenMode = ScreenMode.Readonly;
			}

			return true;
		}

		public checkScreenRoles(
			roles: Hca.HiLO.Model.Identity.Roles | Hca.HiLO.Model.Identity.Roles[]
		): boolean {

			var currentUser = this.users.getCurrentUser();
			var screenRoles = roles ? _.flatten([roles]) : [];

			if (!_(currentUser.roles).some((x: Hca.HiLO.Model.Identity.Roles) => (screenRoles.some(r => r === x)))) {
				this.userMessages.addMessage('You do not have the required role(s) to access this screen',
					UserMessageType.Error);
				this.screenMode = ScreenMode.NoAccess;
				return false;
			}

			return true;
		}

		public canClose(): angular.IPromise<boolean> {

			var defer = this.$q.defer<boolean>();

			if (!this.hasUnsavedChanges() || this.errorHandler.errorShown) {
				defer.resolve(true);
			} else {
				var messageBox = this.modal.messageBox(
					'Please Confirm',
					'Are you sure you want to navigate away from this screen? Any changes made will not be saved.',
					[DialogOutcome.ok, DialogOutcome.cancel],
					true,
					true
				);

				messageBox.result.then((outcome: DialogOutcome) => {
					defer.resolve(outcome === DialogOutcome.ok);
				},
					() => {
						defer.resolve(false);
					});
			}

			return defer.promise;
		}

		protected mainForm() {
			return this.formHelper.mainForm();
		}

		private registerFormFooterAnchor(): void {
			$('main .form-footer')
				.on('inview',
				(event: Event, isInView: boolean) => {
					if (isInView) {
						this.unanchorFormFooter();
					} else {
						this.anchorFormFooter();
					}
				});
		}

		private anchorFormFooter(): void {
			$('.form-footer')
				.wrapInner('<div class="form-footer-inner"><div class="container-fluid"></div></div>')
				.addClass('anchored');
		}

		private unanchorFormFooter(): void {
			$('.form-footer').removeClass('anchored');
			$('.form-footer-inner > .container-fluid > ').unwrap().unwrap();
		}

	}

}